import { Component, ViewChild } from '@angular/core';
import { CommonService } from 'src/service/common.service';
import { GridBaseCase } from '../../grid/grid.base.case';
import { BaseCase } from '../../../basecase';
import { ActivatedRoute } from '@angular/router';
import { HttpCustomerService, MessageclientService } from 'src/service';
import { WebParameterContext } from 'src/model/common';
import { Platform, IonInfiniteScroll, ModalController,AlertController } from '@ionic/angular';
import { ReasonsDifferencesPage } from '../../reasons-differences/reasons-differences.page'
declare var app;

@Component({
  selector: 'app-product-inventory-approval',
  templateUrl: './product-inventory-approval.component.html',
  styleUrls: ['./product-inventory-approval.component.scss']
})
export class ProductInventoryApprovalComponent extends GridBaseCase {
  month: any = new Date();
  searchDate = null;
  searcholdDate=null;
  tabinde:number= 0;
  RecordCount: Number = 0;//列表总数量
  dataArrayList: Array<any> = [];//数据列表
  dataArrayListDetails: Array<any> = [];//产品列表
  pageName: string;
  searchValue:any="";//产品名称
  yeardate:any =new Date(); // 可以显示下一年
  RemarkBH:any=""; // 驳回原因
  backgroundurl:any ; //确定取消
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  constructor(
    private http: HttpCustomerService,
    private com: CommonService,
    private msg: MessageclientService,
    private activaRouter: ActivatedRoute,
    public baseService: BaseCase,
    public modal: ModalController,
    public alertCtrl:AlertController,
    private alertController: AlertController,
  ) { 
    super();
    const _date = new Date();
    // const _month = _date.getMonth() + 1;
    // this.month = _date.getFullYear() + "/" + (_month < 10 ? ("0" + _month) : _month);
    this.baseService.FixedSubmitBtn.configName = "productInventoryApproval";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.text = "批量驳回";
    this.baseService.FixedSubmitBtn.type = 26;
    console.log("库存审批");
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    /**
     * 设置默认当前年月
     */
    const _month = _date.getMonth() + 1;
    this.month = _date.getFullYear() + "-" + (_month < 10 ? ("0" + _month) : _month)+"-01";
  }

  changeMontheach(type, $event:any = "") {
    const that=this;
    let t = type;
    let current = new Date(that.month);
    let current_year = null;
    let current_month = null;
    if (t == 'pre') {
      current_year = current.getFullYear();
      current_month = that.getmonth(current.getMonth());
    } else if (t == 'next') {
      if((current.getMonth()+2)>12){
        current_year = current.getFullYear()+1;
        current_month = "01";
      }else{
        current_year = current.getFullYear();
        current_month = that.getmonth(current.getMonth() + 2);
      }
    } else if (t == 'datetime') {
      console.log($event.detail.value);
      current_year = $event.detail.value.split("-")[0];
      current_month = $event.detail.value.split("-")[1];
      console.log(  current_year);
      console.log(current_month)
     
    }

    if (current_month == 13) {
      current_year += 1;
      current_month = that.getmonth(1);
    } else if (current_month == 0) {
      current_year -= 1;
      current_month = 12;
    }
    //获取月份对应的天数
    let d = new Date(current_year, current_month, 0);
    // console.log(d.getDate());

    let startmonthDay = current_year + "-" + current_month + "-" + "01 00:00:00";
    let endmonthDay = current_year + "-" + current_month + "-" + d.getDate() + " 23:59:59";
    // this.searchDate = current_year + "-" + current_month;
    that.searchDate = that.com.BetweenDate(startmonthDay, endmonthDay);
    that.month = current_year + '-' + current_month;
    console.log(that.month,"99999999999999")
    that.searchDate =startmonthDay;
    that.searcholdDate = endmonthDay;
    if (t == 'datetime') {
      that.LoadData(1);
    }
   
  }
  serarEvent(event){
    this.LoadData(1);
  }
  getmonth(month: Number) {
    let months: any = month;
    if (month < 10) {
      months = "0" + month
    }
    return months;
  }
  // 切换
   // 切换显示
   tabEven(num){
    const that = this;
    that.tabinde = num;
    if(num){
      that.baseService.FixedSubmitBtn.type = 9999;
    }else{
      that.baseService.FixedSubmitBtn.type = 26;
    }
    that.LoadData(1);
   };
  // 下拉显示
  arrowSee(event, item,i) {
    const that = this;
    item.Show = true;
     that.ProductInfoList(item);
  }
  // 下拉列表隐藏
  arrowhide(event, item,i) {
    const that = this;
    item.Show = false;
    that.ProductInfoList(item);
  }

 //备注输入
//  RemarkInputItem(e,item) {
//   let that = this;
//   if (e && e.target.value) {
//       if( item.color){
//         item.color=false;
//       }
//     if (e.target.value.length > 300) {
//       e.target.value = e.target.value.substr(0, 300);
//       item.Remark = e.target.value;
//     }
//   }
// }
loadMoreData(event) {
  let that = this;
  if (that.RecordCount == that.dataArrayList.length) {
    that.infiniteScroll.disabled = true;
  } else {
    that.PageNumber++;
    that.LoadData(that.PageNumber);
  }
} 
LoadData(PageNumber){
  let that = this;
  that.PageNumber = PageNumber;
  if (PageNumber == 1) {
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
  }
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  const pageid = that.activaRouter.snapshot.paramMap.get('id');
  let body = new WebParameterContext();
  body.ConfigName = "GetGiftApprovalList";
  body.OpType = "query";
  body.ConfigType = "view";
  body.RowsPerPage = app.RowsPerPage;
  body.PageNumber = PageNumber;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.ClientType = 2;
  body.Client.Name = "product";
  body.RequestBody={};
  if(that.searchValue){
    body.RequestBody["shortName"]=that.searchValue;
  }
  if (!that.searchDate) {
    let nowyear: any = that.com.getNow.split('-')[0];
    let nowmonth: any = that.com.getNow.split('-')[1];
    body.RequestBody["beginDate"] = nowyear + "-" + nowmonth + "-" + "01" + " 00:00:00";
    let day = new Date(nowyear, nowmonth, 0);
    body.RequestBody["endDate"] = nowyear + "-" + nowmonth + "-" + day.getDate() + " 23:59:59";
   
  }else{
    if(that.searchDate && that.searcholdDate){
      body.RequestBody["beginDate"] = that.searchDate;
      body.RequestBody["endDate"]= that.searcholdDate;
    }
  }
  body.RequestBody["state"]=that.tabinde;
  body.RequestBody = JSON.stringify(body.RequestBody);
  that.http.post(app.DEFAULTURL, body).then(data => {
    if (PageNumber == 1) {
      that.dataArrayList = [];
      that.apiObj['status'] = data.ResponseMessage.Success;
      that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      that.loading = true;
    } else {
      that.infiniteScroll.complete();
    }
    if (data.ResponseMessage.Success) {
      data.Status.Datas.forEach(item => {
        if(item.InventoryDate){
          item.InventoryDate=item.InventoryDate.replace(/-/g,"/").replace("Z",'').replace("-00:00",'').replace("T","");
        }
        item.isCheck = false;
        item.Show=false;
        that.dataArrayList.push(item);
      });
      if(that.dataArrayList.length>0){
        if(!that.tabinde){
          that.baseService.FixedSubmitBtn.type = 26;
        }
      }else{
        that.baseService.FixedSubmitBtn.type = 9999;
      }
       /****上拉加载数据begin****/
       that.RecordCount = data.Status.RecordCount;
       if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
         that.infiniteScroll.disabled = true;
       } else {
         that.infiniteScroll.disabled = false;
       }
       /****上拉加载数据end****/
    }else{
      that.apiObj['status'] = false;
      that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      that.loading = true;
    }

  }).catch(error => {
    that.apiObj['status'] = false;
    that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
    that.loading = true;
    console.log(error);
  });
}
/**
 * 产品名称列表
 * @param batchNumber 
 */
ProductInfoList(items:any){
  let that = this;
  items.errorMessage="";
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  const pageid = that.activaRouter.snapshot.paramMap.get('id');
  let body = new WebParameterContext();
  body.ConfigName = "GetGiftApprovalDetails";
  body.OpType = "query";
  body.ConfigType = "view";
  // body.RowsPerPage = 15;
  body.PageNumber = 1;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.ClientType = 2;
  body.Client.Name = "product";
  body.RequestBody={};
  body.RequestBody["batchNumber"]=items.ApproveNo;
  body.RequestBody["state"]=that.tabinde;
  body.RequestBody = JSON.stringify(body.RequestBody);
  that.http.post(app.DEFAULTURL, body).then(data => {
    items.dataArrayListDetails=[];
    if (data.ResponseMessage.Success) {
      if( data.Status.Datas.length>0){
        data.Status.Datas.forEach(item => { 
          if(item.DamagedPictureUrl){
            item["imgUrlArr"]=[];
            let obj={};
            item.DamagedPictureUrl= item.DamagedPictureUrl.split(",");
            item.DamagedPictureUrl.forEach(element => {
              console.log(element)
              element =(app.FileUoloadUrl+element).replace(app.ImagePlaceholder,app.SmallImageType);
              // obj["url"] = element;
              item.imgUrlArr.push(element);
            });
           
          }
          items.dataArrayListDetails.push(item);
        });
      }else{
        items.errorMessage = "暂无数据";
      }
    }else{
      items.errorMessage = data.ResponseMessage.ErrorMessage;
    } 
  }).catch(error => {
    console.log(error);
  });
}
  /**
   * 返回这个月有多少天
   * @param data 当前日期
   */
  getCountDays(data){
    let curDate:any = new Date(data.replace("-","/"));
    /* 获取当前月份 */
        var curMonth = curDate.getMonth();
        curDate.setMonth(curMonth + 1);
        curDate.setDate(0);
        return curDate.getDate();
  }
  async presentModaldifferences() {
    var that=this;
    // debugger;
 
    const modal = await this.modal.create({
      component: ReasonsDifferencesPage,
      cssClass: 'reasons-differences',
      componentProps: {
       'srltype':"驳回",
       "dataArrayList": that.dataArrayList
      }
    });
 
      await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data)
    that.RemarkBH = data.modalStatusvalue;
    that.backgroundurl =data.backurl;

    // if(data&&data.request)
    // {
    //   that.Remark=data["result"]||"";
    //   arrayDataList.forEach((item)=>{
    //     item["Remark"]=that.Remark;
    //   });
    //   // that.requestData(arrayDataList,true);
    // }else{
    //   return;
    // }

  }
  // 驳回原因的弹出框
  async presentAlertInputbh() {
    const that = this;
    const alert = await this.alertController.create({
      header: '请输入驳回原因',
      mode:"ios",
      inputs: [
        {
          name: 'cravingforRemkbh',
          type: 'text',
          label: '请输入驳回原因',
          value: '',
          min: 6
        }
      ],
      buttons: [
        {
          text: "取消",
          role: 'cancel',
          cssClass: 'secondary btn-cancel',
          handler: (cancel) => {
            //console.log(cancel,"cancel");
          }
        },
        {
          text: "确认",
          cssClass: 'btn-okay',
          handler: (Okay) => {
            if (Okay && Okay["cravingforRemkbh"]) {
              that.EventSubmitClickbh(Okay.cravingforRemkbh)
            } else {
              that.msg.Alert("驳回原因不能为空").then(()=>{
                that.presentAlertInputbh();
              });
              
            }
          }
        }
        
      ]
    });

    await alert.present();
  }
  /**
   * 提交数据
   * @param isbool 驳回/审批
   */
  EventSubmitClick(isbool){
    const that=this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const pageid = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.ConfigName = "ApproveGiftInventory";
    body.OpType = "add";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;;
    body.PageNumber = that.PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    body.Client.Name = "product";
    body.RequestBody={};
    let retsult:Array<any> = [];
  
    that.dataArrayList.forEach(items=>{
      if(items.isCheck){
        retsult.push(items.ApproveNo);
      }
    });
    if(retsult.length<=0){
      that.msg.Alert("请选择需要审批的产品");
     
      return;
    }
    if(!isbool && retsult.length>0 ){
      // that.presentModaldifferences();
      that.presentAlertInputbh()
      return
    }
   
    // if(that.backgroundurl == 1){
    //   body.RequestBody["reasonsRejection"] =  that.RemarkBH;
    // }
     
    body.RequestBody["approveNo"]=retsult.toString();
    if(isbool){
      body.RequestBody["approveState"]=1;
    }else{
      body.RequestBody["approveState"]=2;
      body.RequestBody["rejectReason"] =  that.RemarkBH;
    }
    body.RequestBody = JSON.stringify(body.RequestBody);
    that.msg.Confirm("确定提交吗？","取消","确定").then(res=>{
      if(res){
        that.http.post(app.DEFAULTURL, body).then(data => {
          if (data.ResponseMessage.Success) {
            that.msg.Alert("提交成功").then(d=>{
              that.LoadData(1);
            });
          }else{
            that.msg.Alert(res.ResponseMessage.ErrorMessage);
          }
        }).catch(error => {
          that.msg.Alert("请求失败,请联系管理员");
        });
      }

    });
  }
  // 驳回
  EventSubmitClickbh(cravingforRemkbh){
    
    const that=this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const pageid = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.ConfigName = "ApproveGiftInventory";
    body.OpType = "add";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;;
    body.PageNumber = that.PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    body.Client.Name = "product";
    body.RequestBody={};
    let retsult:Array<any> = [];
  
    that.dataArrayList.forEach(items=>{
      if(items.isCheck){
        retsult.push(items.ApproveNo);
      }
    });
    body.RequestBody["approveNo"]=retsult.toString();
      body.RequestBody["approveState"]=2;
      body.RequestBody["rejectReason"] = cravingforRemkbh;
    
    body.RequestBody = JSON.stringify(body.RequestBody);
    that.msg.Confirm("确定提交吗？","取消","确定").then(res=>{
      if(res){
        that.http.post(app.DEFAULTURL, body).then(data => {
          if (data.ResponseMessage.Success) {
            that.msg.Alert("提交成功").then(d=>{
              
              that.LoadData(1);
            });
          }else{
            that.msg.Alert(res.ResponseMessage.ErrorMessage);
          }
        }).catch(error => {
          that.msg.Alert("请求失败,请联系管理员");
        });
      }

    });
  }
  /**
  * 全选状态切换
  */
 EventCheckAllToggle() {
  console.log("EventCheckAllToggle");
  const that = this;
  if (that.baseService.FixedSubmitBtn["isCheckAll"]) {
    that.dataArrayList.forEach(items => {
      console.log(items, "集合");
      items.isCheck = true;
    });
  } else {
    that.dataArrayList.forEach(items => {
      items.isCheck = false;
    });
  }
}
checkItem(item,i,event){
  const that=this;
  if (item.isCheck) {
    item.isCheck = false;
  } else {
    item.isCheck = true;
  }
  let istrue:number=0;
  that.dataArrayList.forEach(items => {
    if(items.isCheck){
      istrue++;
    }
  });
  if(istrue==that.dataArrayList.length){
    that.baseService.FixedSubmitBtn["isCheckAll"]=true;
  }else{
    that.baseService.FixedSubmitBtn["isCheckAll"]=false;
  }
}
    /**
     * 
     * @param i 查看照片
     */
     imgPreview(item,items,i) {
      let that = this;
      let url = [];
      item.imgUrlArr.forEach(ite=>{
        let u = null;
        if(ite.indexOf("data:") > -1){
          u = ite
        }else{
          u = ite.trim().replace(app.SmallImageType,app.BigImageType);
        }
        url.push(u);
      })
      let ImgPreview = {
        imgUrl: url,
        index: i
      }
      that.com.setHistoryUrl(false);
      // localStorage.setItem("ImgPreview",JSON.stringify(ImgPreview));
      // that.router.navigate(["/tabs/contact/ImgPreview"]);
      that.com.Go("/tabs/contact/ImgPreview/"+that.com.getNowDatetime,{
        ImgPreview: JSON.stringify(ImgPreview)
      });
    }

}
